import { Navigate, useLocation } from 'react-router-dom';
import { needsEmailVerification, useAuth } from '../context/AuthContext';

function ProtectedRoute({ children }) {
  const { user, isAuthenticated, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return null;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (needsEmailVerification(user)) {
    return <Navigate to="/verify-email" state={{ from: location }} replace />;
  }

  return children;
}

export default ProtectedRoute;
